import { ContactFormValues } from "./ContactUs.schema";

export const contactUsDefaultValues: ContactFormValues = {
  custuname: "",
  custemail: "",
  custorg: "",
  phone1: "",
  cid: "",
  req: "",
};
